module.exports = __webpack_public_path__ + "img/book.fe6c618b.png";